import { convertToNumber } from "./convertToNumber";

export const sortByPrice = (arr, sortBy) => {
  if (sortBy === "salary-low-to-high") {
    return arr
      ?.slice()
      ?.sort(
        (a, b) =>
          convertToNumber(a.salary) -
          convertToNumber(b.salary)
      );
  }
  if (sortBy === "salary-high-to-low") {
    return arr
      ?.slice()
      ?.sort(
        (a, b) =>
          Number(b.salary.split(",").join("")) -
          Number(a.salary.split(",").join(""))
      );
  }
  return arr
};
